/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MinimalInputs */

const cs_enum_minimal = /** @type {(inputs: Enum_MinimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimální`)
};

const en_enum_minimal = /** @type {(inputs: Enum_MinimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimal`)
};

/**
* | output |
* | --- |
* | "Minimal" |
*
* @param {Enum_MinimalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_minimal = /** @type {((inputs?: Enum_MinimalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MinimalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_minimal(inputs)
	return cs_enum_minimal(inputs)
});